import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import SubStepper from '../../../components/stepper/SubStepper.component'
import { IMPORT_SUB_STEPS, IMPORT_SUB_STEP_IDS } from '../constants'
import {
  getPulsaraCurrentSubStep,
  getPulsaraDetailsVitals,
  getPulsaraDetailsLabs,
  getPulsaraDetailsAttachmentList,
  getPulsaraLoading,
} from '../selectors'

function getImportStepperProps(
  currentSubStep: number,
  hasVitalsOrLabs: boolean,
  hasAttachments: boolean
): { steps: { id: number; title: string }[]; currentStep: number } {
  const stepIds: number[] = []
  if (hasVitalsOrLabs) stepIds.push(IMPORT_SUB_STEP_IDS.VITALS_LABS)
  if (hasAttachments) stepIds.push(IMPORT_SUB_STEP_IDS.ATTACHMENTS)

  if (stepIds.length === 0) return { steps: [], currentStep: 1 }

  const steps = stepIds.map((id, index) => {
    const title = IMPORT_SUB_STEPS.find((s) => s.id === id)?.title ?? ''
    return { id: index + 1, title }
  })
  const currentStep = stepIds.indexOf(currentSubStep) + 1 || 1
  return { steps, currentStep }
}

const PulsaraSubStepper: React.FC = () => {
  const { t } = useTranslation()
  const currentSubStep = useSelector(getPulsaraCurrentSubStep)
  const loading = useSelector(getPulsaraLoading)
  const vitals = useSelector(getPulsaraDetailsVitals)
  const labs = useSelector(getPulsaraDetailsLabs)
  const attachmentList = useSelector(getPulsaraDetailsAttachmentList)

  const hasVitalsOrLabs = (vitals?.length ?? 0) > 0 || (labs?.length ?? 0) > 0
  const hasAttachments = (attachmentList?.length ?? 0) > 0 || loading === 'attachments'

  const { steps, currentStep } = useMemo(
    () => getImportStepperProps(currentSubStep, hasVitalsOrLabs, hasAttachments),
    [currentSubStep, hasVitalsOrLabs, hasAttachments]
  )

  if (steps.length === 0) return null
  return <SubStepper currentStep={currentStep} stepLabel={t('pulsara.Imports')} steps={steps} />
}

export default PulsaraSubStepper
